import { render, staticRenderFns } from "./identifications-section.vue?vue&type=template&id=6931a8a4&scoped=true"
import script from "./identifications-section.vue?vue&type=script&lang=ts"
export * from "./identifications-section.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6931a8a4",
  null
  
)

export default component.exports